import { Component } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { AssetRecoveryIncident } from '../../../../types';
import { UiModule } from '../../../../components/ui.module';

type CellAssetRecoveryActionsParams = ICellRendererParams<AssetRecoveryIncident> & {
  showReportButton?: boolean;
};

@Component({
  selector: 'app-cell-asset-recovery-actions',
  imports: [UiModule, MatTooltipModule, RouterModule],
  templateUrl: './cell-asset-recovery-actions.component.html',
})
export class CellAssetRecoveryActionsComponent implements ICellRendererAngularComp {
  public params!: CellAssetRecoveryActionsParams;
  public showReportButton = true;

  agInit(params: CellAssetRecoveryActionsParams) {
    this.params = params;
    this.showReportButton = params.showReportButton ?? true;
  }

  refresh(params: CellAssetRecoveryActionsParams) {
    this.params = params;
    this.showReportButton = params.showReportButton ?? true;
    return true;
  }
}
